import { IMenuItem } from '../../models/menu.model';

export const accountMenu: IMenuItem = {
  label: `Finance`,
  path: `account-desk`,
  id: 'MID_ACCOUNT_DESK',
  icon: 'fa fa-book',
  children: [
    {
      path: `license-operation-levy`,
      label: `License Operation Levy`,
      id: 'MID_ACCOUNT_LICENSE_OPERATION_LEVY',
    },
    {
      path: `company-accounts`,
      label: `Financial Accounts`,
      id: 'MID_ACCOUNT_COMPANY_ACCOUNTS',
    },
    {
      path: `valuation`,
      label: `Valuation`,
      id: 'MID_ACCOUNT_VALUATION',
    },
    {
      path: `rbc`,
      label: `RBC`,
      id: 'MID_ACCOUNT_RBC',
    },
    {
      path: `fire-service-fund`,
      label: `Fire Service Fund`,
      id: 'MID_ACCOUNT_FIRE_SERVICE_FUND',
    },
    {
      path: `policyholder-protection-fund`,
      label: `Policyholder Protection Fund`,
      id: 'MID_ACCOUNT_POLICYHOLDER_PROTECTION_FUND',
    },
    {
      path: `expenses`,
      label: `Expenses`,
      id: 'MID_ACCOUNT_EXPENSES',
    },
    {
      path: `ecowas-account-wallet`,
      label: `Wallet`,
      id: 'MID_SET_UP_ECOWAS_ACCOUNT_WALLET',
    },
  ],
};
